import { Dispatch, SetStateAction, useEffect } from 'react';

import { FormikProps } from 'formik';

import { useAppDispatch } from '../../../../../../../store/hooks';
import { IdFile } from '../../../../../../shared/models/id-file.model';
import { appsFilesActions } from '../../../../../store/slices/apps-files.slice';
import { AppDetailFormFormikModel } from '../../models/app-detail-form-formik.model';
import { populateAppDetailsForm } from '../../utils/populate-app-details-form';

export const usePopulateAppDetailsForm = (
  isOnEdit: boolean,
  formik: FormikProps<AppDetailFormFormikModel>,
  setIconFile: Dispatch<SetStateAction<IdFile[] | undefined>>,
  setScreenshotFiles: Dispatch<SetStateAction<IdFile[] | undefined>>,
  appId?: string
) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const applicationId = parseInt(appId as string, 10);
    if (isOnEdit && !isNaN(applicationId)) {
      populateAppDetailsForm(
        applicationId,
        formik,
        dispatch,
        setScreenshotFiles,
        setIconFile
      );
    }

    return () => {
      dispatch(appsFilesActions.resetAppsFilesState());
    };
  }, []);
};
